import React, { useEffect, useCallback } from "react";
import { useGlobalContext } from "../../../store/global";
import { markHrPopupSeen } from "../../../utils/data";

export default function AccessGranted() {
  const { closeModal, user } = useGlobalContext();
  const assetBase = process.env.PUBLIC_URL || "";
  const gifSrc = `${assetBase}/assets/images/access-granted.gif`;

  const handleClose = useCallback(() => {
    closeModal();
  }, [closeModal]);

  useEffect(() => {
    const key = user?.id ? `hrPopupSeen:${user.id}` : null;
    if (key) localStorage.setItem(key, "true");
    markHrPopupSeen();
  }, [closeModal, user?.id]);

  return (
    <div className="popup-inner access-granted-inner">
      <div className="access-granted-media">
        <picture>
          <source srcSet={gifSrc} type="image/gif" />
          <img src={gifSrc} alt="Access granted" />
        </picture>
        <div className="popup-actions">
          <div
            className="popup-actions--button popup-actions--button__confirm"
            onClick={handleClose}
          >
            CONTINUE
          </div>
        </div>
      </div>
    </div>
  );
}
